function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProgramListApi, deleteProgramApi } from '@/api/program';
import { customerSelectApi, selectContractListApi } from '@/api/enterprise';
import { roterPre } from '@/settings';
export default {
  name: 'programList',
  components: {
    oaFromBox: function oaFromBox() {
      return import('@/components/common/oaFromBox');
    },
    addProgram: function addProgram() {
      return import('./components/addProgram');
    },
    taskDrawer: function taskDrawer() {
      return import('../programTask/index');
    },
    dynamicsDrawer: function dynamicsDrawer() {
      return import('./dynamics');
    }
  },
  data: function data() {
    return {
      loading: false,
      tableData: [],
      tableFrom: {
        page: 1,
        limit: 15,
        types: 0,
        status: '',
        admins: [],
        scope_frame: 'all',
        scope_normal: 0,
        eid: [],
        cid: []
      },
      total: 0,
      customerList: [],
      contractList: [],
      taskDrawer: false,
      taskTitle: '',
      programId: 0,
      treeData: [{
        options: [{
          value: 0,
          label: '全部项目'
        }, {
          value: 1,
          label: '我负责的'
        }, {
          value: 2,
          label: '我参与的'
        }, {
          value: 3,
          label: '我创建的'
        }]
      }],
      search: [{
        field_name: '项目名称',
        field_name_en: 'name',
        form_value: 'input'
      }, {
        field_name: '状态',
        field_name_en: 'status',
        form_value: 'select',
        data_dict: [{
          value: 5,
          name: '已延期'
        }, {
          value: 4,
          name: '进行中'
        }, {
          value: 3,
          name: '待开始'
        }, {
          value: 1,
          name: '已暂停'
        }, {
          value: 2,
          name: '已关闭'
        }]
      }, {
        field_name: '关联客户',
        field_name_en: 'eid',
        form_value: 'checkbox',
        props: {
          collapseTags: true
        },
        data_dict: []
      }, {
        field_name: '关联合同',
        field_name_en: 'cid',
        form_value: 'checkbox',
        props: {
          disabled: true,
          collapseTags: true,
          value: []
        },
        data_dict: []
      }, {
        form_value: 'manage'
      }],
      treeDefault: 0
    };
  },
  watch: {
    // 'tableFrom.eid'(val) {
    //   if (this.search.length > 0) {
    //     for (let i = 0; i < this.search.length; i++) {
    //       if (this.search[i].field_name_en == 'cid') {
    //         this.search[i].props.disabled = !val.length
    //         this.search[i].data_dict = []
    //         break
    //       }
    //     }
    //   }
    //   if (val.length) {
    //     this.getContractList(val)
    //   }
    // }
  },
  created: function created() {
    this.getCustomer();
  },
  mounted: function mounted() {
    this.getTableData();
  },
  methods: {
    handleClose: function handleClose() {
      this.taskDrawer = false;
    },
    nowTime: function nowTime() {
      var now = new Date();
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始计数，所以加1，然后用padStart保证两位数
      var day = now.getDate().toString().padStart(2, '0'); // 日期使用padStart保证两位数
      var nowData = "".concat(year, "-").concat(month, "-").concat(day);
      return nowData;
    },
    // 获取表格数据
    getTableData: function getTableData(tableFrom, type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              data = tableFrom ? tableFrom : _this.tableFrom;
              _context.next = 4;
              return getProgramListApi(data);
            case 4:
              res = _context.sent;
              _this.tableData = res.data.list;
              _this.total = res.data.count;
              _this.loading = false;
              if (type === 1) {
                _this.programId = res.data.list[0].id;
                _this.taskTitle = res.data.list[0].name;
                _this.taskDrawer = false;
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    addProgram: function addProgram() {
      this.taskDrawer = true;
    },
    addTask: function addTask() {
      this.$refs.taskDrawerRef.addProgram();
    },
    batchOperation: function batchOperation() {
      this.$refs.taskDrawerRef.batchOperation();
    },
    // 获取客户数据
    getCustomer: function getCustomer() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, i;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return customerSelectApi();
            case 2:
              result = _context2.sent;
              _this2.customerList = result.data;
              i = 0;
            case 5:
              if (!(i < _this2.search.length)) {
                _context2.next = 12;
                break;
              }
              if (!(_this2.search[i].field_name_en == 'eid')) {
                _context2.next = 9;
                break;
              }
              _this2.search[i].data_dict = result.data;
              return _context2.abrupt("break", 12);
            case 9:
              i++;
              _context2.next = 5;
              break;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getContractList: function getContractList(eid) {
      if (eid) {
        this.getContract(eid);
      }
    },
    // 获取合同数据
    getContract: function getContract(eid) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, j, i;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return selectContractListApi({
                data: eid
              });
            case 2:
              result = _context3.sent;
              _this3.contractList = result.data;
              for (j = 0; j < result.data.length; j++) {
                result.data[j].value = result.data[j].id;
                result.data[j].name = result.data[j].title;
              }
              i = 0;
            case 6:
              if (!(i < _this3.search.length)) {
                _context3.next = 13;
                break;
              }
              if (!(_this3.search[i].field_name_en == 'cid')) {
                _context3.next = 10;
                break;
              }
              _this3.search[i].data_dict = result.data;
              return _context3.abrupt("break", 13);
            case 10:
              i++;
              _context3.next = 6;
              break;
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getTableData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getTableData();
    },
    // 编辑项目
    handleEdit: function handleEdit(row, type) {
      this.$refs.addProgram.openBox(row.id, type);
    },
    // 项目动态
    goDynamics: function goDynamics(row) {
      this.programId = row.id;
      this.$refs.dynamicsDrawer.drawer = true;
      // this.$router.push(`${roterPre}/program/programList/dynamics?id=${row.id}`)
    },
    // 项目任务
    goTask: function goTask(row) {
      this.$router.push("".concat(roterPre, "/program/programList/taskDetails?id=").concat(row.id));
    },
    // 删除项目
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$modalSure('删除项目，同时会删除项目中的工作项！你确定要删除该项目吗').then(function () {
        deleteProgramApi(row.id).then(function (res) {
          _this4.getTableData();
          _this4.$refs.addProgram.handleClose();
        });
      });
    },
    setPayStatus: function setPayStatus(row, status) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              data = {
                id: row.id,
                name: row.name,
                status: status
              };
              _context4.next = 3;
              return enterprisePayTypeStatusApi(data);
            case 3:
              _this5.getTableData();
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.tableFrom = {
          page: 1,
          limit: 15,
          types: [],
          name: '',
          status: '',
          eid: [],
          cid: []
        };
      } else {
        this.tableFrom = data;
      }
      this.getTableData(this.tableFrom);
    },
    treeChange: function treeChange(data) {
      this.tableFrom.types = data.value;
      this.getTableData(this.tableFrom);
    }
  }
};